<template>
  <b-tabs class="tabs__container">
    <b-tab
      v-for="tab of tabsData"
      :key="tab.id"
      :disabled="tab.value === 'designer' && isNewTable"
      @click="sendSelectedTabValueToParent(tab.value)"
    >
      <template #title>
        <font-awesome-icon :icon="['fas', tab.icon]" />
        <span class="ml-2">{{ tab.label }}</span>
      </template>
    </b-tab>
  </b-tabs>
</template>

<script>

export default {
  name: 'TabsComponent',
  props: ['tabsData', 'isNewTable'],
  methods: {
    sendSelectedTabValueToParent(tab) {
      this.$emit('get-selected-tab', tab);
    },
  },
};
</script>